import type { ReactNode } from 'react'

export type NoticeTone = 'error' | 'success' | 'info'

const TONE_CLASS: Record<NoticeTone, string> = {
  error: 'border-danger/40 bg-[var(--danger-soft)] text-deep',
  success: 'border-teal/30 bg-mint text-deep',
  info: 'border-line bg-paper text-deep',
}

interface NoticeProps {
  tone?: NoticeTone
  children: ReactNode
  className?: string
}

/** Inline, accessible feedback for the activity form. */
export function Notice({ tone = 'error', children, className }: NoticeProps) {
  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      aria-live={tone === 'error' ? 'assertive' : 'polite'}
      className={[
        'rounded-md border px-4 py-3 text-sm font-semibold',
        TONE_CLASS[tone],
        className ?? '',
      ]
        .join(' ')
        .trim()}
    >
      {children}
    </div>
  )
}
